import type { ReactNode } from "react";
import { ReviewerAvatar } from "./reviewer-avatar";
import { formatReviewDate } from "./format-review-date";

interface FooterReview {
  date?: string;
  location?: string;
  name: string;
  profileImageUrl?: string;
}

interface WallReviewFooterProps {
  review: FooterReview;
  showDates: "yes" | "no";
}

// The reviewer and the date along the bottom of a wall card.
const WallReviewFooter = ({ review, showDates }: WallReviewFooterProps): ReactNode => (
  <div className="jobsite:border-t jobsite:border-border/50 jobsite:pt-3">
    <div className="jobsite:flex jobsite:items-center jobsite:justify-between">
      <div className="jobsite:flex jobsite:items-center jobsite:gap-3">
        <ReviewerAvatar review={review} />
        <div className=" jobsite:text-sm jobsite:font-heading jobsite:text-card-foreground">
          {review.name}
        </div>
      </div>
      {showDates === "yes" && Boolean(review.date) && (
        <div className="jobsite:text-xs jobsite:text-muted-foreground jobsite:shrink-0">
          {formatReviewDate(review.date)}
        </div>
      )}
    </div>
  </div>
);

export { WallReviewFooter };
